/* eslint-disable @typescript-eslint/no-floating-promises */
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type Store from 'ember-data/store';
import { t } from 'ember-intl';
import ActionsButtonBase from 'parog-web/components/alerts-and-notifications/actions-button-base';
import type NotificationTriggeredJournalEvent from 'parog-web/models/notification-triggered-journal-event';
import type SemeiaSessionService from 'parog-web/services/session';

interface ActionsNotificatonSignature {
  Args: {
    notification: NotificationTriggeredJournalEvent;
    showComment(): void;
    color?: string;
    openDetails?(): void;
  };
}

export default class ActionsNotification extends Component<ActionsNotificatonSignature> {
  @service declare session: SemeiaSessionService;
  @service declare store: Store;

  get shouldDisplayProcessingButton() {
    return this.#unprocessedNotifications.length != 0;
  }

  get #unprocessedNotifications() {
    return this.store
      .peekAll('notification-triggered-journal-event')
      .filter(
        notif =>
          notif.triggeringJournalEventId ===
            this.args.notification.triggeringJournalEventId &&
          notif.triggeringJournalEventType ===
            this.args.notification.triggeringJournalEventType &&
          notif.isUnprocessed === true
      );
  }

  onNotificationProcessed = async (
    /** This function is used {@link ActionsButtonBase}, the first parameter is required
     * because always calls the callback using an item, here we does not use that first argument */
    _,
    actionTaken: string | undefined,
    e?: Event
  ) => {
    if (!actionTaken) {
      return;
    }

    if (actionTaken == 'comment') {
      this.args.showComment();
      this.args.openDetails?.();
      return;
    }

    if (e) this.#stopPropagation(e);
    this.#unprocessedNotifications.forEach(notif => {
      notif.processNotification(actionTaken);
    });
  };

  #stopPropagation = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();
  };

  <template>
    <ActionsButtonBase
      @item={{@notification}}
      @dataTestButton='notification-action'
      @color='text-primary'
      @onProcessed={{this.onNotificationProcessed}}
    >
      <:dropdownItems as |DropdownItem|>

        <DropdownItem @key='comment'>
          Ajouter un commentaire
        </DropdownItem>

        {{#if this.shouldDisplayProcessingButton}}
          <div class='divider'></div>

          {{#let (t 'notification.processing.type.treated') as |label|}}
            <DropdownItem @key='treated' aria-label={{label}}>
              {{label}}
            </DropdownItem>
          {{/let}}

        {{/if}}
      </:dropdownItems>
    </ActionsButtonBase>
  </template>
}
